import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, Scale, Star, TrendingUp } from 'lucide-react';

const WhyNeedSection = ({ onOpenContactForm }) => {
  return (
    <section className="py-24 bg-white" data-testid="why-need-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-16 items-stretch">
          <div className="rounded-lg overflow-hidden">
            <img src="https://images.unsplash.com/photo-1767972159871-b9f5d320be2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxpbnRlbGxlY3R1YWwlMjBwcm9wZXJ0eSUyMGxhdyUyMGJvb2tzJTIwZ2F2ZWx8ZW58MHx8fHwxNzc1NTA4MjA3fDA&ixlib=rb-4.1.0&q=85" alt="Legal trademark document" className="w-full h-full object-cover" data-testid="why-need-image" />
          </div>
          <div className="space-y-6">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500">Why It Matters</p>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}} data-testid="why-need-heading">
              Why Federal Trademark Registration Is Non-Negotiable
            </h2>
            <p className="text-sm leading-relaxed text-zinc-600">
              Without a registered trademark, your brand has no legal shield. Competitors can use your name, Amazon will block your Brand Registry application, and you have zero standing in federal court. Registration changes all of that.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: Shield, title: 'Legal Shield', desc: 'Nationwide exclusive rights' },
                { icon: Scale, title: 'Court Standing', desc: 'Sue infringers in federal court' },
                { icon: Star, title: 'Amazon Access', desc: 'Brand Registry enrollment' },
                { icon: TrendingUp, title: 'Business Value', desc: 'IP adds real asset value' },
              ].map(({ icon: Icon, title, desc }) => (
                <div key={title} className="card-hover bg-[#F4F4F5] rounded-lg p-4">
                  <Icon className="w-5 h-5 text-[#002FA7] mb-2" />
                  <h4 className="text-sm font-semibold text-[#09090B]">{title}</h4>
                  <p className="text-xs text-zinc-500">{desc}</p>
                </div>
              ))}
            </div>
            <Button onClick={onOpenContactForm} className="btn-lift bg-[#002FA7] hover:bg-[#001D66] text-white px-6 py-5 font-semibold rounded-md" data-testid="why-need-cta">
              Protect My Brand <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNeedSection;
